import { createAction } from '@reduxjs/toolkit';

export const statusActions = {
  reset: 'reset/status',
  resetReport: 'reset/report',
  setPaymentLoad: 'load/payment/set',
};

export const resetStatus = createAction<Array<string> | null | undefined>(
  statusActions.reset
);
export const resetReportStatus = createAction(statusActions.resetReport);
export const setPaymentLoad = createAction<boolean>(statusActions.setPaymentLoad);
